import {FComponent} from "./f-component";

interface P {
    next: (value) => any;
    delay: number;
}
interface S {
    value: boolean;
}


export class Wait extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: false,
        };
        let timeout = setTimeout(() => {
            timeout = null;
            this.setState({value: true});
        }, props.delay);
        this.onUnmount(() => timeout && clearTimeout(timeout));
    }

    render() {
        const {next} = this.props;
        const {value} = this.state;

        return next(value);
    }
}
